/**
 * Ventana de la política de reprogramación ("Tus horarios de reprogramación" /
 * "Mis horarios de reprogramación"): empieza exactamente 24hs después del
 * momento en el que se hace la consulta (no a las 00:00 del día siguiente) y
 * se extiende por 7 días desde ahí.
 *
 * Compartido por WeeklyPsychologistCalendar.tsx (cálculo real de horas
 * libres/agendadas) y por RescheduleSummaryModal.tsx / RescheduleMyStatsModal.tsx
 * (subtítulo y tooltip), para que el texto mostrado siempre coincida con el
 * rango realmente usado para computar las horas.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

export interface ReschedulePolicyWindow {
  start: Date;
  end: Date;
}

/** start = now + 24h, end = start + 7 días. */
export function getReschedulePolicyWindow(now: Date = new Date()): ReschedulePolicyWindow {
  const start = new Date(now.getTime() + DAY_MS);
  const end = new Date(start.getTime() + 7 * DAY_MS);
  return { start, end };
}

const DAYS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

function fmtDayAndTime(d: Date): string {
  const dayName = DAYS_ES[d.getDay()];
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dayName} ${dd}/${mm} ${hh}:${min}`;
}

/** Fecha y hora exacta de inicio, para el subtítulo (ej. "miércoles 10/06 15:32"). */
export function formatReschedulePolicyWindowStart(window: ReschedulePolicyWindow): string {
  return fmtDayAndTime(window.start);
}

/** Rango completo, para el tooltip (ej. "Desde miércoles 10/06 15:32 hasta miércoles 17/06 15:32"). */
export function formatReschedulePolicyWindowRange(window: ReschedulePolicyWindow): string {
  return `Desde ${fmtDayAndTime(window.start)} hasta ${fmtDayAndTime(window.end)}`;
}
